import React from "react";
import { C, font } from "../config/theme";

/**
 * Message d'état réutilisable — erreur, vide, avertissement, info.
 *
 * Props :
 * - type     : "error" | "empty" | "warning" | "info" (défaut: "info")
 * - message  : texte principal affiché
 * - detail   : (optionnel) texte secondaire plus discret
 * - action   : (optionnel) { label, onClick } pour bouton d'action
 * - style    : (optionnel) override de style conteneur
 */

const VARIANTS = {
  error:   { icon: "⚠", bg: C.redBg,   color: C.red,    border: C.red },
  empty:   { icon: "📭", bg: C.bg,      color: C.slate,  border: C.border },
  warning: { icon: "⏳", bg: "#FFFBEB", color: "#92400E", border: "#F59E0B" },
  info:    { icon: "ℹ", bg: "#EFF6FF", color: "#1E40AF", border: C.blue },
};

export default function StatusMessage({ type = "info", message, detail, action, style }) {
  const v = VARIANTS[type] || VARIANTS.info;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
        padding: "14px 18px",
        borderRadius: 8,
        border: `1px solid ${v.border}20`,
        background: v.bg,
        fontFamily: font,
        ...style,
      }}
    >
      {/* Icône */}
      <span style={{ fontSize: 18, lineHeight: "24px", flexShrink: 0 }}>{v.icon}</span>

      {/* Contenu */}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 14, color: v.color, fontWeight: 500, lineHeight: "20px" }}>
          {message}
        </div>
        {detail && (
          <div style={{ fontSize: 12, color: C.slate, marginTop: 4, lineHeight: "16px" }}>
            {detail}
          </div>
        )}
      </div>

      {/* Bouton d'action optionnel */}
      {action && (
        <button
          onClick={action.onClick}
          style={{
            padding: "6px 14px",
            fontSize: 13,
            fontWeight: 500,
            fontFamily: font,
            color: v.color,
            background: "transparent",
            border: `1px solid ${v.border}40`,
            borderRadius: 6,
            cursor: "pointer",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
